import React, { useCallback, useEffect, useState } from 'react';
import { fetchMyBillingSummary } from '../api/companyBilling';
import './OnlinePaymentWidget.css';

// DD/MM/YYYY, meme convention d'affichage que le mock fourni par l'utilisateur
// (isoToDisplay de DateField.jsx est MM/DD/YYYY — different usage ici, pas de
// saisie, juste de l'affichage, donc pas reutilise tel quel).
const fmtDate = (iso) => {
  if (!iso) return '—';
  const [y, m, d] = String(iso).split('-');
  return `${d}/${m}/${y}`;
};

const money = (n) => Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// Widget "Online Payment" — apercu de facturation toujours visible sur le
// dashboard (demande explicite 2026-09-18), rafraichi a chaque connexion
// (fetch au montage, le dashboard etant la page d'atterrissage apres login)
// + bouton Refresh manuel. "Pending Amount" = solde total DU TOUTES factures
// confondues (donc une dette d'une periode passee compte aussi, pas
// seulement la derniere facture) — affiche en NEGATIF quand la company doit
// de l'argent, convention du mock ("-830.4").
const OnlinePaymentWidget = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(() => {
    setLoading(true);
    setError('');
    fetchMyBillingSummary()
      .then(setSummary)
      .catch(() => setError('Chargement impossible.'))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  const latest = summary?.latest_invoice;
  const pendingAmount = summary ? -Number(summary.total_balance || 0) : null;

  // "Pay Online" ouvre la page de paiement (PaymentInvoicePage.jsx) dans un
  // nouvel onglet, ciblant la derniere facture — demande explicite
  // 2026-09-18 ("il ouvrir une nouvelle page a cote"). Sans facture, rien a
  // ouvrir (bouton desactive plutot que naviguer vers un id inexistant).
  const handlePayOnline = () => {
    if (!latest) return;
    window.open(`/paiement/${latest.id}`, '_blank', 'noopener');
  };

  return (
    <div className="opw-container">
      <div className="opw-header">
        <span className="opw-title">Online Payment</span>
        <button className="opw-toggle" onClick={() => setCollapsed(!collapsed)}>
          {collapsed ? '+' : '−'}
        </button>
      </div>
      {!collapsed && (
        <div className="opw-body">
          {error && <p className="opw-error">{error}</p>}

          <div className="opw-field">
            <label className="opw-label">Latest Invoice</label>
            <input
              className="opw-input"
              type="text"
              value={loading ? '...' : (latest ? latest.reference : 'Aucune facture')}
              readOnly
            />
          </div>
          <div className="opw-field">
            <label className="opw-label">Invoice Date</label>
            <input
              className="opw-input"
              type="text"
              value={loading ? '...' : fmtDate(latest?.period_end)}
              readOnly
            />
          </div>
          <div className="opw-field">
            <label className="opw-label">Pending Amount</label>
            <input
              className={`opw-input${pendingAmount < 0 ? ' opw-input-due' : ''}`}
              type="text"
              value={loading ? '...' : money(pendingAmount ?? 0)}
              readOnly
            />
          </div>
          <button className="opw-btn" onClick={load} disabled={loading}>
            {loading ? 'Refresh...' : 'Refresh'}
          </button>
          <button className="opw-btn" onClick={handlePayOnline} disabled={!latest}>Pay Online</button>
        </div>
      )}
    </div>
  );
};

export default OnlinePaymentWidget;
